var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shown)?_c('div',{staticClass:"banner",style:(_vm.styles)},[_vm._t("default"),(_vm.closingX)?_c('RButton',{staticClass:"banner-close-btn",attrs:{"type":"close","size":"lg"},on:{"click":function($event){_vm.shown = false}}}):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }